import { ChangeDetectionStrategy, Component, computed, effect, inject, input } from '@angular/core';
import { GalleryDto, GalleryThemeDto } from '@nusign/picflow-backend-types';
import { loadFont } from '../../../lib/load-font';
import { DialogService } from '../../../services/dialog.service';
import { ButtonMenuItemComponent } from '../../../shared/components/button-menu-item/button-menu-item.component';
import { ContextMenuComponent } from '../../../shared/components/context-menu/context-menu.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { DeleteCustomThemeDialogComponent } from '../../dialogs/delete-custom-theme-dialog/delete-custom-theme-dialog.component';
import { RenameCustomThemeDialogComponent } from '../../dialogs/rename-custom-theme-dialog/rename-custom-theme-dialog.component';
import { ApplyTypographyStylesDirective } from '../../directives/apply-typography-styles.directive';
import { CoverDesignComponent } from '../cover-design/cover-design.component';

@Component({
  selector: 'app-custom-theme-item',
  imports: [
    ApplyTypographyStylesDirective,
    CoverDesignComponent,
    SvgComponent,
    ContextMenuComponent,
    ButtonDirective,
    ButtonMenuItemComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './custom-theme-item.component.html',
  styleUrl: './custom-theme-item.component.scss',
  host: { '[style.background-color]': 'theme().layout_page.background_color' },
})
export class CustomThemeItemComponent {
  private dialogs = inject(DialogService);
  customTheme = input.required<GalleryThemeDto>();
  gallery = input.required<GalleryDto>();
  theme = computed(() => this.customTheme()?.theme);

  constructor() {
    effect(() => {
      const theme = this.customTheme()?.theme;
      if (!theme) return;

      const fonts = new Set<string>();
      fonts.add(theme.cover.title_typography.font_family);
      // fonts.add(theme.cover.paragraph_typography.font_family);
      fonts.add(theme.section.title_typography.font_family);
      fonts.add(theme.section.paragraph_typography.font_family);

      fonts.forEach(font => {
        if (font) {
          loadFont(font);
        }
      });
    });
  }

  renameTheme() {
    this.dialogs.open(RenameCustomThemeDialogComponent, { theme: this.customTheme() });
  }
  deleteTheme() {
    this.dialogs.open(DeleteCustomThemeDialogComponent, { theme: this.customTheme() });
  }
}
